import {Component, input} from '@angular/core';
import {ScorecardRow} from "../rows/row";
import {NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-scorecard-row',
    templateUrl: './row.component.html',
    imports: [
        NgForOf,
        NgIf
    ],
    styleUrls: ['./row.component.css']
})
export class RowComponent {
    row = input.required<ScorecardRow>();
}
